import { AbstractMap3sqd8xvg0030s as AbstractMap } from './AbstractMap.mjs';
import {
  HashMapKeysDefaultd8xopyn6vbgh as HashMapKeysDefault,
  HashMapValuesDefault3j1xghpfb6bpq as HashMapValuesDefault,
} from './HashMapEntryDefault.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMutableMapClass;
function AbstractMutableMap() {
  if (AbstractMutableMapClass === VOID) {
    class $ extends AbstractMap() {
      static q7() {
        var $this = this.t7();
        $this.o7_1 = null;
        $this.p7_1 = null;
        return $this;
      }
      u7() {
        return HashMapKeysDefault().w7(this);
      }
      x7() {
        return HashMapValuesDefault().z7(this);
      }
      y4() {
        var tmp0_elvis_lhs = this.o7_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.u7();
          this.o7_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      z4() {
        var tmp0_elvis_lhs = this.p7_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.x7();
          this.p7_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      s4() {
        this.l3().s4();
      }
      c5(from) {
        this.o6();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var key = _destruct__k2r9zo.m3();
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.n3();
          this.a5(key, value);
        }
      }
      b5(key) {
        this.o6();
        var iter = this.l3().p1();
        while (iter.q1()) {
          var entry = iter.r1();
          var k = entry.m3();
          if (equals(key, k)) {
            var value = entry.n3();
            iter.p6();
            return value;
          }
        }
        return null;
      }
      o6() {
      }
    }
    initMetadataForClass($, 'AbstractMutableMap', VOID, VOID, [KtMutableMap()]);
    AbstractMutableMapClass = $;
  }
  return AbstractMutableMapClass;
}
//region block: exports
export {
  AbstractMutableMap as AbstractMutableMapyktux9ubhc1g,
};
//endregion

//# sourceMappingURL=AbstractMutableMap.mjs.map
